
import React from 'react';

type FormStatesProps = {
  state: 'idle' | 'submitting' | 'success' | 'error';
  customMessage?: string;
};

export const FormStates: React.FC<FormStatesProps> = ({ state, customMessage }) => {
  if (state === 'success') {
    return (
      <div className="max-w-xl mx-auto text-center py-12">
        <div className="bg-green-50 rounded-xl p-6 border border-green-200">
          <div className="w-16 h-16 mx-auto bg-green-100 rounded-full flex items-center justify-center text-green-600 mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-green-800 mb-2">Merci pour votre feedback !</h2>
          <p className="text-green-700">
            Votre feedback a été envoyé avec succès. Le destinataire en sera notifié.
          </p>
        </div>
      </div>
    );
  }

  if (state === 'error') {
    return (
      <div className="max-w-xl mx-auto text-center py-12">
        <div className="bg-red-50 rounded-xl p-6 border border-red-200">
          <div className="w-16 h-16 mx-auto bg-red-100 rounded-full flex items-center justify-center text-red-600 mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-red-800 mb-2">Une erreur est survenue</h2>
          <p className="text-red-700">
            {customMessage || "Impossible d'envoyer votre feedback. Veuillez réessayer plus tard."}
          </p>
        </div>
      </div>
    );
  }

  return null;
};

export const LoadingState: React.FC = () => (
  <div className="flex justify-center py-12">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
  </div>
);

export const ErrorState: React.FC<{ error: string }> = ({ error }) => (
  <div className="max-w-xl mx-auto py-8">
    <div className="bg-red-50 rounded-xl p-6 border border-red-200">
      <h2 className="text-xl font-bold text-red-800 mb-2">Erreur</h2>
      <p className="text-red-700">{error}</p>
    </div>
  </div>
);
